import React, { useState, useEffect} from 'react';

// import CollectionPreferences from "@amzn/awsui-components-console/collection-preferences";
import {
    Box,
    Container,
    Header,
    Pagination,
    SpaceBetween,
    Button,
} from "@amzn/awsui-components-react";
import { Link, useLocation, useParams } from "react-router-dom";
import { getCleanedItemContent } from '../CloseHelperMethods';

function DefaultCarouselComponent(props) {
  const [carouselIndex, setCarouselIndex] = React.useState(1);
  const [jsonContent, setJsonContent] = React.useState(props?.jsonContent)

  useEffect (() => {
    setJsonContent(props?.jsonContent)
  }, [props?.jsonContent])

  useEffect(() => {
    props.updateCarouselIndex(carouselIndex)
  },[carouselIndex])

  
if (jsonContent?.items?.length) {
    return (<>
      <Container
    fitHeight
        header={
            <Header
                variant="h2"
            >
               <span style={{ color: "#006ce0", fontWeight: "700", fontSize:"20px", }}>{jsonContent?.items[carouselIndex - 1]?.title}</span>
            </Header>
        }
        footer={
          <>
            <Button
                onClick={() => {
                    props?.onOpenDashboardClick(jsonContent, carouselIndex)
                }}
            >
            Open
          </Button>
          <Box float='right'>
        <Pagination
        currentPageIndex={carouselIndex}
        onChange={({ detail }) => {

            setCarouselIndex(detail?.currentPageIndex)
        }
        }
        pagesCount={jsonContent?.items?.length}
        />
        </Box>
        </>
        }
        >
          
        <p>{getCleanedItemContent(jsonContent?.items[carouselIndex - 1]?.description)}</p>
        
    </Container>
    </>)
  } else {
    return (<>
      <Container
        fitHeight
        header={
          <Header
            variant="h2"
          >
            <span style={{ color: "#006ce0", fontWeight: "700", fontSize: "20px", }}>{jsonContent?.title}</span>
          </Header>
        }
      >
        <p><span style={{ color: "#db0000" }}>No Dashboards featured!</span></p>
      </Container>
    </>)
  }
}

export default DefaultCarouselComponent;